// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Action column for relationship list
 */
import constants from 'logic/data/Izenda.RelationshipConstants';

import React from 'react';
import classnames from 'classnames';
import { isEmpty, isNil, some } from 'lodash/fp';
import { FIELDCHECK } from 'logic/data/Izenda.RelationshipConstants';

export default function ActionColumn(relationshipDetails: any): any {
  const parentProps = this.props;
  const onCopyIconClick = () => {
    const { validation } = parentProps;

    parentProps.store.copy(relationshipDetails).then(function() {
      validation.validate();
      return null;
    });
  };

  const onDeleteIconClick = relationship => {
    const { store, validation } = parentProps;
    const confirmMessage = constants.CONFIRM_DELETE_RELATIONSHIP;

    parentProps
      .confirmFn('Confirmation', {
        description: confirmMessage
      })
      .then(() => store.handleDeleteAction(relationship))
      .then(relationships => {
        validation.reset();
        if (some(item => !isNil(item), relationships)) {
          const allErrors = store.getInvalidErrors(FIELDCHECK);
          validation.updateErrors(allErrors);
        }
      });
  };

  /**
   * Render component
   */
  const renderErrorIcon = () => {
    const generalEror = relationshipDetails.generalEror;
    return !isEmpty(generalEror) ? (
      <span className='icon-attention fail-color error-icon-size' title={generalEror} />
    ) : (
        ''
      );
  };

  const renderCopyIcon = () => {
    return (
      <a onClick={onCopyIconClick}>
        <span title='Copy Relationship' className='icon-copy' />
      </a>
    );
  };

  const renderDeleteIcon = () => {
    const onDelete = () => onDeleteIconClick(relationshipDetails);
    const isSystemRelationship = relationshipDetails.systemRelationship;
    const classes = classnames('icon-cancel', {
      'disabled-elm': isSystemRelationship
    });
    return (
      <a onClick={isSystemRelationship ? null : onDelete}>
        <span title='Delete Relationship' className={classes} />
      </a>
    );
  };

  /**
   * Render
   */
  return (
    <div className='action-in-cell u_textCenter'>
      {renderErrorIcon()}
      {renderCopyIcon()}
      {renderDeleteIcon()}
    </div>
  );
}


// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/Relationship/Izenda.ActionColumn.js